import { Component, OnInit, ViewChild } from '@angular/core';
import { CDSMask } from '@app/utils/cds-mask';
import { DemonstrativoDeResultadoService } from '@app/services/demonstrativo-de-resultado.service';
import { DemonstrativoDeResultado } from '@app/models/demonstrativo-de-resultado.model';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ITreeOptions, TreeComponent } from '@circlon/angular-tree-component';

@Component({
  selector: 'app-demonstrativo-de-resultado',
  templateUrl: './demonstrativo-de-resultado.component.html',
  styleUrls: ['./demonstrativo-de-resultado.component.scss']
})

export class DemonstrativoResultadoComponent implements OnInit {

  @ViewChild('tree', { static: true }) treeComponent: TreeComponent;
  options: ITreeOptions = {
    displayField: 'Codigo',
    idField: 'Id',
    childrenField: 'DemonstrativosDeResultado'
  };

  cdsMask: CDSMask = new CDSMask();
  lstErros: string[];
  lstGrupoPai: DemonstrativoDeResultado[];
  arvoreDR: DemonstrativoDeResultado[];
  demonstrativo: DemonstrativoDeResultado = new DemonstrativoDeResultado();
  bsModalRef: BsModalRef;
  aguardandoSolicitacao: boolean = false;

  constructor(
    private demonstrativoDeResultadoService: DemonstrativoDeResultadoService,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.obterDocumento();
  }
  selecionaItem(node: any) {

    this.demonstrativo = { ...node };
  }

  obterDocumento() {
    this.demonstrativoDeResultadoService.obterCompleto().subscribe(
      (data: DemonstrativoDeResultado[]) => {
        this.lstGrupoPai = [];
                this.arvoreDR = this.Expanded(data);
      });
  }

  Expanded(data: DemonstrativoDeResultado[]) {
    for (const dr of data) {
      this.lstGrupoPai.push(dr);
      if (dr.DemonstrativosDeResultado) {
        dr['isExpanded'] = true;
        this.Expanded(dr.DemonstrativosDeResultado);
      }
    }
    return data;
  }

  novo() {
    this.demonstrativo = new DemonstrativoDeResultado();
    this.lstErros = [];
    this.obterDocumento();
  }

  gravar() {
    if (this.demonstrativo.Id) {
      this.aguardandoSolicitacao = true;
      this.demonstrativoDeResultadoService.alterar(this.demonstrativo).subscribe(
        () => {
          this.obterDocumento();
          this.aguardandoSolicitacao = false;
        },
        (data: any) => {
          this.lstErros = data.error.errors;
          this.aguardandoSolicitacao = false;
        }
      );
    } else {
      this.aguardandoSolicitacao = true;
      this.demonstrativoDeResultadoService.adicionar(this.demonstrativo).subscribe(
        () => {
          this.novo();
          this.aguardandoSolicitacao = false;
        },
        (data: any) => {
          this.lstErros = data.error.errors;
          this.aguardandoSolicitacao = false;
        }
      );
    }
  }

  deletar() {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente deletar ' + this.demonstrativo.Codigo + ' - ' + this.demonstrativo.Descricao + '?';
    this.bsModalRef.content.confirmar = () => {
      this.demonstrativoDeResultadoService.deletar(this.demonstrativo.Id)
        .subscribe(
          () => {
            this.obterDocumento();
            this.novo();
          },
          (data: any) => { this.lstErros = data.error.errors; }
        );
    };
  }

  validaFormula(event: any) {
    const pattern = /[0-9 Gg/*\-\+]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  validaNumero(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
}
